const BootstrapVariant = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  OUTLINE_SECONDARY: 'outline-secondary',
  OUTLINE_PRIMARY: 'outline-primary',
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
  SMALL: 'sm',
  LINK: 'link',
  MEDIUM: '',
  LARGE: 'lg',
  XLARGE: 'xl',
  XXLARGE: 'xxl',
  MAX: 'max',
};

export default BootstrapVariant;
